// eslint-disable-next-line import/prefer-default-export
export const ID_POINT_CHANNEL_ID = 1;
